export default "__VITE_ASSET__BhhWEzQ4__"